import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import { useHistory } from "react-router-dom";
import { Link, Route, Switch } from "react-router-dom";
import { Box } from "@material-ui/core";
import { getCookie } from "../services/Cookies";
import PrivateRoute from "../services/PrivateRoute";
import { CommonCss } from '../services/CommonCss';
import Customersetting from "../pages/customerdomain/Customersetting";

import {
  DashboardLayout,
  Home,
  Contracts,
  Reports,
  ShipDetails,
  Ships,
  Orderkit,
  Samplogic,
  Scheduler,
  Transformerschedular,
  Account,
  AdminPanel,
  AddUser,
  Trends,
 SampleStatus,
  Alerts,
  Help,
  Support,
  Supporttickets,
  SupportticketEdit,
  Customerdomain,
  //Blocklistdomain,
  addcustomeruser,
  editcustomeruser,
  TransformersMain,
  EnergyCalculation,
  EnergyConversation,
  ViscosityConversion,
  Co2Calculator,
  GravityConversation,
  IgnitionQuality,
  NoxCalculator,
  QuantityConversation,
  QuantityDetermination,
  SoxCalculator,
  TemperatureConversion,
  ViscocityCalculation,
  BlendCalculation,
  dataaccess,
  Decarbonisation,
  Analytics,
  CII_Dashboard,
  Global_Filter,
  BunkerAlert,
  
  

} from "../../components/pages";
import Blacklistdomain from "../pages/customerdomain/Blacklistdomain";
import blackcustomeruser from "../pages/customerdomain/blackcustomeruser";
import Editblacklistcustomerdomain from '../pages/customerdomain/Editblacklistcustomerdomain';
import { LeftSideMenu, Header } from "../shared";
import { useSelector, useDispatch } from 'react-redux';
import TrendsShips from "../pages/trendsShips/Trends";
import TrendsShipsOCM from "../pages/trendsShipsOCM/Trends";
 import UserAnalytics from "../pages/UserAnalytics/UserAnalytics";
 import BunkerAlertForm from "../pages/BunkerAlert/BunkerAlertForm";
import BunkerMaster from "../pages/bunkermaster/BunkerMaster";
 //import Global_Filters from "../pages/Global_Filter/Global_Filter";
const drawerWidth =230;
const headerHeight = 130;

const useStyles = makeStyles((theme) => ({
  footerBox:{
    position:"fixed",
    bottom:"1vh",
    cursor:"pointer"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  mainDiv: {
   width: `calc(100% - ${drawerWidth}px)`,
 marginLeft: `${drawerWidth}px`,
    paddingTop: `${headerHeight}px`,
    minHeight: `calc(100vh - 25px)`,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    //width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerTop: {
    paddingTop: `${headerHeight}px`,
  },
  mainHeader: {
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
  },
  pageLoading: {
    position: "fixed",
    width: "100%",
    height: "100%",
    background: "#1e1b1bb5",
    zIndex: 9999,
    top: "0px",
    color: "#fff"
  }

}));

export default function MiniDrawer(props) {
  // ////console.log(props);
  const classes = useStyles();
  const commonClasses = CommonCss();
  const theme = useTheme();
  const history = useHistory();
  const [open, setOpen] = React.useState(true);
  const [authenticated, setAuthenticated] = useState(true);
  const loading = useSelector(state => state.RootReducer);
  // ////console.log(loading,'loading');
  useEffect(() => {
    // ////console.log("dashboard", getCookie("username"));
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  localStorage.setItem("fromDate", "2020-02-01");
  localStorage.setItem("toDate", "2020-02-29");

  return (
    <div>
      <Box
        className={classes.mainHeader}
        position="fixed"
        width={1}
        bgcolor="#fff"
        zIndex={1300}
      >
        <Header
          username={getCookie("name")}
          profileImg={getCookie("profileImg")}
        />
      </Box>
      <CssBaseline />
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx({
            [classes.drawerOpen + " left-nav"]: open,
            [classes.drawerClose + "  left-nav"]: !open,
          }),
        }}
      >
        <Box className={classes.drawerTop}>
          <LeftSideMenu {...props} />
        </Box>
        <Divider />
      </Drawer>

      <div className={classes.mainDiv}>
        <Switch>
          {/* <PrivateRoute
            exact
            path="/dashboard/home"
            pagename={"home"}
            component={Home}
          /> */}
          <PrivateRoute
            exact
            path="/dashboard"
            pagename={"dashboard"}
            component={DashboardLayout}
          />
          <PrivateRoute
            exact
            path="/dashboard/contracts"
            pagename={"contracts"}
            component={Contracts}
          />
          <PrivateRoute
            exact
            path="/dashboard/assets"
            component={Ships}
            pagename={"assets"}
          />
          <PrivateRoute
            exact
            path="/dashboard/assets/:title/:subtitle"
            pagename={"assetsShip"}
            component={ShipDetails}
          />
          <PrivateRoute
            exact
            path="/dashboard/reports"
            component={Reports}
            pagename={"reports"}
          />
          <PrivateRoute
            exact
            path="/dashboard/sample-status"
            component={SampleStatus}
            pagename={"sampleStatus"}
          />

          <PrivateRoute
            exact
            path="/dashboard/order-a-kit"
            component={Orderkit}
            pagename={"orderKit"}
          />

          <PrivateRoute
            exact
            path="/dashboard/samplogic"
            component={Samplogic}
            pagename={"samplogic"}
          />
          <PrivateRoute
            exact
            path="/dashboard/scheduler"
            component={Scheduler}
            pagename={"scheduler"}
          />
           <PrivateRoute
            exact
            path="/dashboard/Notificationscheduler/:ship"
            component={Scheduler}
            pagename={"Notificationscheduler"}
          />
           <PrivateRoute
            exact
            path="/dashboard/scheduler-transformer"
            component={Transformerschedular}
            pagename={"Transformerschedular"}
          />
          <PrivateRoute
            exact
            path="/dashboard/account"
            component={Account}
            pagename={"account"}
          />
          <PrivateRoute
            exact
            path="/dashboard/admin"
            component={AdminPanel}
            pagename={"adminPanel"}
          />
          <PrivateRoute
            exact
            path="/dashboard/admin/add-user"
            component={AddUser}
            pagename={"addUser"}
          />
          <PrivateRoute
            exact
            path="/dashboard/admin/edit-user/:email"
            component={AddUser}
            pagename={"editUser"}
          />
          <PrivateRoute
            exact
            path="/dashboard/trends"
            component={Trends}
            pagename={"trends"}
          />
             <PrivateRoute
            exact
            path="/dashboard/trendsships"
            component={TrendsShips}
            pagename={"trendsShips"}
          />
           <PrivateRoute
            exact
            path="/dashboard/trends-ships-ocm"
            component={TrendsShipsOCM}
            pagename={"trendsShipsOCM"}
          />
          <PrivateRoute
            exact
            path="/dashboard/alerts"
            component={Alerts}
            pagename={"trents"}
          />
          <PrivateRoute
            exact
            path="/dashboard/help"
            component={Help}
            pagename={"help"}
          />
          <PrivateRoute
            exact
            path="/dashboard/assets-transformers"
            component={TransformersMain}
            pagename={"transformers"}
          />
          <PrivateRoute
            exact
            path="/dashboard/customer-support"
            component={Support}
            pagename={"support"}
          />
          <PrivateRoute
            exact
            path="/dashboard/Support-Tickets"
            component={Supporttickets}
            pagename={"supporttickets"}
          />
          <PrivateRoute
            exact
            path="/dashboard/SupportticketEdit/:ticketId"
            component={SupportticketEdit}
            pagename={"supportticketedit"}
          />
          <PrivateRoute
            exact
            path="/dashboard/Customerdomain"
            component={Customerdomain}
            pagename={"customerdomain"}
          />
           <PrivateRoute
            exact
            path="/dashboard/Customersetting"
            component={Customersetting}
            pagename={"Customersetting"}
          />
         
           <PrivateRoute
            exact
            path="/dashboard/Blacklistdomain"
            component={Blacklistdomain}
            pagename={"blocklistdomain"}
          />
          <PrivateRoute
            exact
            path="/dashboard/addcustomeruser"
            component={addcustomeruser}
            pagename={"addcustomeruser"}
          />
          <PrivateRoute
            exact
            path="/dashboard/blackcustomerusers"
            component={blackcustomeruser}
            pagename={"blackcustomerusers"}
          />
          <PrivateRoute
            exact
            path="/dashboard/Editblacklistcustomerdomain/:domain/:id/:status"
            component={Editblacklistcustomerdomain}
            pagename={"Editblacklistcustomerdomain"}
          />
          <PrivateRoute
            exact
            path="/dashboard/editcustomeruser/:domainName/:customerName+/:id/:status"
            component={editcustomeruser}
            pagename={"editcustomeruser"}
          />
          <PrivateRoute
          exact
          path="/dashboard/bunkerMaster" 
          component={BunkerMaster} 
          pagename={"bunkermasterlanding"} 
          />
          <PrivateRoute
            exact
            path="/dashboard/bunker-master"
            component={EnergyCalculation}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/EnergyConversation"
            component={EnergyConversation}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/Co2Calculator"
            component={Co2Calculator}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/GravityConversation"
            component={GravityConversation}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/BlendCalculation"
            component={BlendCalculation}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/IgnitionQuality"
            component={IgnitionQuality}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/NoxCalculator"
            component={NoxCalculator}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/QuantityConversation"
            component={QuantityConversation}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/QuantityDetermination"
            component={QuantityDetermination}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/SoxCalculator"
            component={SoxCalculator}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/TemperatureConversion"
            component={TemperatureConversion}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/ViscocityCalculation"
            component={ViscocityCalculation}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/ViscosityConversion"
            component={ViscosityConversion}
            pagename={"bunkermaster"}
          />
          <PrivateRoute
            exact
            path="/dashboard/dataaccess"
            component={dataaccess}
            pagename={"dataaccess"}
          />
           <PrivateRoute
            exact
            path="/dashboard/useranalytics"
            component={UserAnalytics}
            pagename={"UserAnalytics"}
          />
          <PrivateRoute
            exact
            path="/dashboard/Decarbonisation"
            component={Decarbonisation}
            pagename={"Decarbonisation"}
          />
          <PrivateRoute
            exact
            path="/dashboard/analytics"
            component={Analytics}
            pagename={"Analytics"}
          />
          <PrivateRoute
            exact
            path="/dashboard/cii-dashboard"
            component={CII_Dashboard}
            pagename={"CII_Dashboard"}
          />
           <PrivateRoute
            exact
            path="/dashboard/global-filter"
            component={Global_Filter}
            pagename={"Global_Filter"}
          />
          <PrivateRoute
            exact
            path="/dashboard/bunker-alert"
            component={BunkerAlert}
            pagename={"BunkerAlert"}
          />
           <PrivateRoute
           exact
           path="/dashboard/AddBunkerAlert"
           component={BunkerAlertForm}
           pagename={"BunkerAlertForm"}
          />
           <PrivateRoute
            exact
            path="/dashboard/editBunkerAlert/:id"
            component={BunkerAlertForm}
            pagename={"editBunkerAlert"}
          />
        </Switch>
      </div>
      {/* <Box className={classes.pageLoading} style={{ display: loading.padeLoad ? "block" : "none" }}>
        <Box my={5} display="flex" alignItems="center" height={1} justifyContent="center">
          <Box component="img" src={
            process.env.REACT_APP_CUSTOMER_PORTAL_URL +
            "assets/svg/loading.svg"
          } />
        </Box>
      </Box> */}
      {/* <Box display="flex" justifyContent="flex-end"   className={classes.footerBox + " footertext"} component="a" href="http://www.natobotics.com" target="blank">
      <Box component="span" marginTop="5px">Powered By Natobotics </Box>
        <Box
            component="img"
            display="block"
            width="30px"
            src={
              process.env.REACT_APP_CUSTOMER_PORTAL_URL +
              "assets/images/natobotics-logo.png"
            }
          />
        </Box> */}
    </div>
    
  );
}
